import { get } from 'lodash'

import { User, UserFormInput } from './types'
import { t } from '@/lib/helpers'

export const transformUserIntoForm = (data: User): UserFormInput => {
  return {
    nickname: get(data, 'nickname'),
    email: get(data, 'email'),
    point: String(get(data, 'point')),
    occupation: get(data, 'occupation'),
    face_icon: get(data, 'face_icon'),
    birthdate: get(data, 'birthdate'),
    city_id: String(get(data, 'city_id')),
    carbon_reduction_point: get(data, 'carbon_reduction_point'),
    toshi_os_has_connected: get(data, 'toshi_os_has_connected')
      ? t('views.admin.users.form.toshi_os_has_connected_true')
      : t('views.admin.users.form.toshi_os_has_connected_false'),
    toshi_os_unlinked_by_error_at: get(data, 'toshi_os_unlinked_by_error_at'),
    toshi_os_has_agreed: get(data, 'toshi_os_has_agreed'),
    toshi_os_has_enabled_point_service: get(
      data,
      'toshi_os_has_enabled_point_service',
    ),
    toshi_os_points: get(data, 'toshi_os_points'),
    toshi_os_last_fetched_at: get(data, 'toshi_os_last_fetched_at'),
    toshi_os_user_id: get(data, 'toshi_os_user_id'),
  }
}
